export const GET_CAMPAIGN_SURVEY_REQUESTING =
  "survey/GET_CAMPAIGN_SURVEY_REQUESTING";
export const GET_CAMPAIGN_SURVEY_SUCCESS = "survey/GET_CAMPAIGN_SURVEY_SUCCESS";
export const GET_CAMPAIGN_SURVEY_ERROR = "survey/GET_CAMPAIGN_SURVEY_ERROR";

export const GET_SURVEY_REQUESTING = "survey/GET_SURVEY_REQUESTING";
export const GET_SURVEY_SUCCESS = "survey/GET_SURVEY_SUCCESS";
export const GET_SURVEY_ERROR = "survey/GET_SURVEY_ERROR";

export const GET_ACTIVE_SURVEY_REQUESTING =
  "survey/GET_ACTIVE_SURVEY_REQUESTING";
export const GET_ACTIVE_SURVEY_SUCCESS = "survey/GET_ACTIVE_SURVEY_SUCCESS";
export const GET_ACTIVE_SURVEY_ERROR = "survey/GET_ACTIVE_SURVEY_ERROR";

export const SUBMIT_ANSWERS_REQUESTING = "survey/SUBMIT_ANSWERS_REQUESTING";
export const SUBMIT_ANSWERS_SUCCESS = "survey/SUBMIT_ANSWERS_SUCCESS";
export const SUBMIT_ANSWERS_ERROR = "survey/SUBMIT_ANSWERS_ERROR";

export const SET_SURVEY = "survey/SET_SURVEY";

export const GET_ONBOARDING_SURVEY_REQUESTING =
  "survey/GET_ONBOARDING_SURVEY_REQUESTING";
export const GET_ONBOARDING_SURVEY_SUCCESS =
  "survey/GET_ONBOARDING_SURVEY_SUCCESS";
export const GET_ONBOARDING_SURVEY_ERROR = "survey/GET_ONBOARDING_SURVEY_ERROR";
